import { defineNuxtPlugin, parseInt10, useRuntimeConfig } from '#imports';
import { version as htmlVersion } from '../package.json';

export default defineNuxtPlugin(() => {
  function compare(v1: string, v2: string) {
    if (v1 && v2) {
      const v1p = v1.split('.');
      const v2p = v2.split('.');
      if (v1p.length === 3 && v2p.length === 3) {
        for (let i = 0; i < 3; i++) {
          const v1n = parseInt10(v1p[i]);
          const v2n = parseInt10(v2p[i]);
          if (v1n > v2n) {
            return 1;
          } else if (v1n < v2n) {
            return -1;
          }
        }
      }
    }
    return 0;
  }
  const config = useRuntimeConfig();
  const url = `${config.public.CDN_URL}version.json?t=${new Date().getTime()}`;
  $fetch(url).then((res: any) => {
    const com = compare(htmlVersion, res.version);
    // 先暂时统计各种场景的数量
    // 后续可以通过强制刷新页面来获取最新版本的页面
    window.__bl.sum(`release-version:${com}`);
  });
});
